import { sx } from '../../../lib/sx'
import type { Vals } from '../../../demo/vals'

export function PurchaseSuccess({ v }: { v: Vals }) {
  return (
    <div style={sx("position:absolute;inset:0;padding:64px 24px 34px;display:flex;flex-direction:column;background:radial-gradient(120% 60% at 50% 6%,var(--color-blue-900) 0%,var(--bg-primary) 62%)")}>
      <div style={sx("flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:20px;text-align:center;animation:gpop 400ms var(--ease-out)")}>
        <span style={sx("width:88px;height:88px;border-radius:var(--radius-full);background:var(--bg-accent);display:flex;align-items:center;justify-content:center")}>
          <span style={sx("width:40px;height:40px;background:#fff;-webkit-mask:url(/assets/icons/checkmark.svg) center/contain no-repeat;mask:url(/assets/icons/checkmark.svg) center/contain no-repeat")} />
        </span>
        <span style={sx("font-size:var(--fs-6xl);font-weight:var(--fw-bold);letter-spacing:var(--ls-sm);line-height:38px")}>
          Group account created
        </span>
        <span style={sx("font-size:var(--fs-md);line-height:22px;color:var(--text-secondary);max-width:280px")}>
          {v.successBody}
        </span>
        <span style={sx("display:flex;gap:8px;align-items:center;padding:10px 14px;border-radius:var(--radius-full);background:var(--bg-secondary);border:1px solid var(--border-secondary)")}>
          <span style={sx("width:16px;height:16px;background:var(--text-secondary);-webkit-mask:url(/assets/icons/email.svg) center/contain no-repeat;mask:url(/assets/icons/email.svg) center/contain no-repeat")} />
          <span style={sx("font-size:var(--fs-xs);color:var(--text-secondary)")}>
            Receipt sent to michael@corleone.com
          </span>
        </span>
      </div>
      <div style={sx("display:flex;flex-direction:column;gap:10px")}>
        <button onClick={v.toDash} style={sx("height:52px;border-radius:var(--radius-full);border:none;background:var(--bg-accent);color:#fff;font-family:inherit;font-size:var(--fs-md);font-weight:var(--fw-medium);cursor:pointer")}>
          Set up your group
        </button>
        <button onClick={v.skipSetup} style={sx("height:44px;border-radius:var(--radius-full);border:none;background:transparent;color:var(--text-secondary);font-family:inherit;font-size:var(--fs-sm);cursor:pointer")}>
          Setup later
        </button>
      </div>
    </div>
  )
}
